import {
  CreateUserFilterInput,
  CreateUserFilterMutationVariables,
  DeleteUserFilterMutationVariables,
  UserFilter,
} from '@/API';
import { GenericRepository } from '@/repository/GenericRepository.ts';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import * as queries from '@/graphql/queries.ts';
import * as mutations from '@/graphql/mutations.ts';

export class UserFilterRepository extends GenericRepository<UserFilter> {
  constructor() {
    super();
  }

  public async save(userFilter: CreateUserFilterInput) {
    return (
      await this.client.graphql({
        query: mutations.createUserFilter,
        variables: {
          input: userFilter,
        } as CreateUserFilterMutationVariables,
      })
    ).data.createUserFilter;
  }

  public async delete(userFilterId: string) {
    await this.client.graphql({
      query: mutations.deleteUserFilter,
      variables: {
        input: { id: userFilterId },
      } as DeleteUserFilterMutationVariables,
    });
  }

  public async search(options: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: queries.searchUserFilters,
        variables: options,
      })
    ).data.searchUserFilters;
  }
}
